export enum BookingType {
    BBQ, MOVE, HARD_WASTE, NA
}